<template>
    <div>
        <b-dropdown id="flag" dropup  size="sm" right variant="light" class="mt-1 mb-1" :class="priorityClass">
            <b-dd-item-button v-on:click='setPriority(20)'><span class="flag flag-emergency"></span> {{ $t('translations.emergency') }}</b-dd-item-button>
            <b-dd-item-button v-on:click='setPriority(10)'><span class="flag flag-urgent"></span> {{ $t('translations.urgent') }}</b-dd-item-button>
            <b-dd-item-button v-on:click='setPriority(5)'><span class="flag flag-visit"></span> {{ $t(elevated) }}</b-dd-item-button>
            <b-dd-item-button v-on:click='setPriority(0)'><span class="flag flag-routine"></span> {{ $t('translations.routine') }}</b-dd-item-button>
            <b-dd-item-button v-on:click='setPriority(-10)'><span class="flag flag-lower"></span> {{ $t('translations.lower') }}</b-dd-item-button>
        </b-dropdown>
    </div>
</template>


<script>
    /**
     * This is a horrible frankenstein's monster of a component. The original use was with a thread, and so it
     * has a thread property. However it can now be used as a standard input type component so it also has modelValue.
     * Confusing, but it works.
     */
	export default {
		props: {
            thread: {
                default: () => {
                    return {
                        thread_provider: {
                            priority: 0,
                        }
                    };
                }
            },
            thread_id: {
                default: null,
            },
            value: {
            },
            elevated: {
                default: "translations.visit_request"
            }
		},
		data: function(){
			return {
				
			};
		},
		computed: {
			priorityClass() {
				if(this.thread) {
					switch(this.thread.thread_provider.priority) {
						case -10: return "lower"; break;
						case 5: return "visit"; break;
						case 10: return "urgent"; break;
						case 20: return "emergency"; break;
						default: return "routine"; break;
					}
				}
				return "routine";
			},
			
		},
		watch: {
			value() {
                Vue.set(this.thread.thread_provider, 'priority', this.value);
            }
		},
		created() {
        },
		beforeDestroy() {
		},
		mounted() {
            if(this.value !== undefined) {
                Vue.set(this.thread.thread_provider, 'priority', this.value);
            }
		},

		methods: {
            setPriority(priority) {
                if(this.thread_id) {
                    
                    this.setLoading(true);

                    axios.put(this.$root.apiBase + '/threads/prioritise/' + this.thread.id + '/' + priority, {"assigned_group_id": this.new_assigned_group_id, "assigned_user_id": this.new_assigned_user_id}).then((res) => {
                        this.thread.thread_provider.priority = priority;
                        //this.$root.sortRequests();
                        this.setLoading(false);
                        //this.addNotification({type: "success", content: 'Assigned thread to: ' + this.assignee_name});
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "assign");
                    });
                }
                else {
                    Vue.set(this.thread.thread_provider, 'priority', priority);
                    this.$emit("input", priority);
                }
            },
		}
    }
</script>
